<template>
  <div class="row form-group">
    <div class="col-12">
      <p class="label">{{ title }}</p>

      <address-picker
        :model="schema"
        :terc-model="schema.terc._regex"
        :woj-model="schema._woj"
        :pow-model="schema._pow"
        :gmi-model="schema._gmi"
        :city-model="schema._city"
        :street-model="schema._street"
        :post-code-model="schema._postCode"
        :nr-model="schema._nr"
        :local-nr-model="schema._localNr"
        @update="$emit('update')"
      />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import AddressPicker from '@/components/formComponents/AddressPicker';

// @vuese
// Formularz wyboru adresu
export default {
  components: { ...components, AddressPicker },
  props: {
    // schema
    schema: { type: Object, required: true },
    // tytuł pola
    title: { type: String, required: true }
  }
};
</script>
